<template lang='pug'>
  v-container(fill-height)
    v-row.text-xs-center.blue-grey--text.text--darken-1(align='center' justify='center')
      v-col(justify='center' align='center')
        .text-h4.mb-4 Please Confirm Your Email Address
        #confirm-explanation.subheading
          p Please check your email for an email from us to confirm your email address.
          p If you don't see an email from us within the next few minutes, please check your email filters, spam filters, etc. and try&nbsp;
            router-link(to='resend') Resending
</template>


<script>
export default {
  name: 'Confirm',
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #confirm-explanation a {
    color: #546E7A;
  }

  #confirm-explanation a:link {
    text-decoration: underline;
  }

  #confirm-explanation a:visited {
    text-decoration: underline;
  }

  #confirm-explanation a:hover {
    color: #546E7A;
    text-decoration: underline;
  }

  #confirm-explanation a:active {
    color: #546E7A;
    text-decoration: underline;
  }
</style>
